import React from "react";
import { useTranslation } from "react-i18next";
import {
  FiAward,
  FiDollarSign,
  FiShoppingCart,
  FiTruck,
  FiShoppingCart as FiCart,
  FiChevronRight,
} from "react-icons/fi";

import aboutImg from "../../images/supplier_about.png";

const AboutSupplier = () => {
  const { t } = useTranslation();

  return (
    <section className="mahal-about-section">
      <div className="container">
        <div className="row align-items-center">

          {/* LEFT IMAGE */}
          <div className="col-lg-5 mt-4 mt-lg-0">
            <div className="mahal-about-image">
              <img src={aboutImg} alt="Suppliers" />
            </div>
          </div>

          {/* RIGHT CONTENT */}
          <div className="col-lg-7">
            <div className="mahal-about-content">

              {/* Badge */}
              <div className="mahal-subtitle-wrapper">

                <div className="subtitle-icon">
                  <svg
                    viewBox="0 0 64 64"
                    className="chef-icon"
                    fill="currentColor"
                  >
                    <path d="M32 8c-7 0-12 5-12 11v2c-4 1-7 5-7 10 0 6 5 11 11 11h16c6 0 11-5 11-11 0-5-3-9-7-10v-2c0-6-5-11-12-11zm-8 35h16v7H24z" />
                  </svg>
                </div>

                <div className="subtitle-text-pill">
                  {t("for")} {t("suppliers")}
                </div>

                <div className="subtitle-spark">
                  <svg
                    width="30"
                    height="34"
                    viewBox="0 0 30 34"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <line
                      x1="7"
                      y1="6"
                      x2="16"
                      y2="0"
                      stroke="#F57C00"
                      strokeWidth="3.5"
                      strokeLinecap="round"
                    />
                    <line
                      x1="11"
                      y1="17"
                      x2="28"
                      y2="17"
                      stroke="#F57C00"
                      strokeWidth="3.5"
                      strokeLinecap="round"
                    />
                    <line
                      x1="7"
                      y1="28"
                      x2="16"
                      y2="34"
                      stroke="#F57C00"
                      strokeWidth="3.5"
                      strokeLinecap="round"
                    />
                  </svg>
                </div>

              </div>

              {/* Title */}

              <h2 className="supplier-title">

                <span className="supplier-title1">
                  {t("grow_business")}
                </span>

                <span className="supplier-title2">
                  {t("with")}
                </span>

                <div className="supplier-title-bottom">

                  <span className="supplier-from">
                    {t("supplier_from")}
                  </span>

                  <span className="supplier-highlight">
                    {t("supplier_highlight")}
                  </span>

                </div>

              </h2>

              {/* Description */}

              <p className="mahal-desc">
                {t("supplier_desc")}
              </p>

              <p className="mahal-text">
                {t("supplier_text")}
              </p>

              {/* Feature Cards */}

             <div className="about-feature-grid">

  {/* Feature 1 */}
  <div className="about-feature-card">

    <div className="about-feature-icon">
      <FiAward size={28} strokeWidth={2} />
    </div>

    <div className="about-feature-text">
      <h5>{t("highlight1")}</h5>
    </div>

  </div>

  {/* Feature 2 */}
  <div className="about-feature-card">

    <div className="about-feature-icon">
      <FiDollarSign size={28} strokeWidth={2} />
    </div>

    <div className="about-feature-text">
      <h5>{t("highlight2")}</h5>
    </div>

  </div>

  {/* Feature 3 */}
  <div className="about-feature-card">

    <div className="about-feature-icon">
      <FiShoppingCart size={28} strokeWidth={2} />
    </div>

    <div className="about-feature-text">
      <h5>{t("highlight3")}</h5>
    </div>

  </div>

  {/* Feature 4 */}
  <div className="about-feature-card">

    <div className="about-feature-icon">
      <FiTruck size={28} strokeWidth={2} />
    </div>

    <div className="about-feature-text">
      <h5>{t("highlight4")}</h5>
    </div>

  </div>

</div>

              {/* Button */}

              <div className="mahal-btn-group mt-4">

                <a href="/Registration" className="mahal-btn-primary restaurant-btn">

                  <FiCart className="btn-cart-icon1" />

                  <span className="btn-divider1"></span>

                  <span className="btn-text1">
                    {t("become_supplier")}
                  </span>

                  <FiChevronRight className="btn-arrow-icon1" />

                </a>

              </div>

            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default AboutSupplier;